<template>
  <v-row justify-sm="center">
    <v-card 
      class="mt-4"
      width="95%"
      fill
    >
      <v-tabs
        background-color="blue darken-2"
        grow
        dark
      >
        <v-tab>
          <v-icon left>
            mdi-clock-outline
          </v-icon>
          Acceso fuera de horario
        </v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="12">
                  <lottie :options="loadingAnimation" :height="250" :width="500" />
                </v-col>
              </v-row>
              <div class="text-body-1 text-justify">
                No es posible acceder a la plataforma Mi UBGA, en este momento porque su intento de ingreso se realizó fuera del horario laboral permitido. Por favor, inténtelo nuevamente dentro del horario establecido.
              </div>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-card>
  </v-row>
</template>

<script>
import Lottie from 'vue-lottie';
import animationData from '@/assets/stop.json';

export default {
  components:{
    'lottie': Lottie
  },
  data: () => ({
    loadingAnimation: { animationData }
  })
}
</script>
